import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-additional-information',
  templateUrl: './additional-information.component.html',
  styleUrls: ['./additional-information.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdditionalInformationComponent implements OnInit {

  @Input() form: UntypedFormGroup;
  @Input() isSubmitted: boolean = false;
  @Input() isHidden: boolean = false;

  protected formValidation: UntypedFormGroup;

  constructor() { }

  ngOnInit(): void {
    this.formValidation = this.form;
  }

}
